import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { renderAllowedHtml } from '../allowedHtml';

export type InfoSnackbarProps = {
    open: boolean;
    onClose: () => void;
    stackIndex?: number;
    text: string | React.ReactNode;
};

function InfoSnackbar({ open, onClose, text, stackIndex = 0 }: InfoSnackbarProps) {
    return (
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            autoHideDuration={6000}
            onClose={onClose}
            style={stackIndex > 0 ? { bottom: 24 + stackIndex * 60 } : undefined}
        >
            <Alert
                onClose={onClose}
                severity="info"
                sx={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}
            >
                {renderAllowedHtml(text)}
            </Alert>
        </Snackbar>
    );
}

export default InfoSnackbar;
